import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface CollapsiblePanelProps {
  id: string;
  title: string;
  children: React.ReactNode;
  className?: string;
  isCollapsed: boolean;
  onToggle: (id: string) => void;
}

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  id,
  title,
  children,
  className = '',
  isCollapsed,
  onToggle
}) => {
  return (
    <div className={`collapsible-panel corruptible-ui ${className}`}>
      <button
        className="panel-header"
        onClick={() => onToggle(id)}
      >
        <span className="panel-title">{title}</span>
        <span className={`panel-toggle ${isCollapsed ? 'collapsed' : ''}`}>
          {isCollapsed ? '▼' : '▲'}
        </span>
      </button>
      <AnimatePresence>
        {!isCollapsed && (
          <motion.div
            className="panel-content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
